// The sentence for "since you were here", built from counts. Pure so it
// can be pinned: the strip renders it, nothing else touches the words.

import { BIRD_NAME } from '../world/identity.js'

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`

// "kptn", "kptn and ducc", "kptn, ducc and bitterBin46", "kptn, ducc and
// 2 others": one "and", at the end, whatever the count.
function people(names, n) {
  if (!names?.length) return plural(n, 'person', 'people')
  const rest = n - names.length
  const tail = rest > 0 ? plural(rest, 'other', 'others') : null
  const all = tail ? [...names, tail] : [...names]
  if (all.length === 1) return all[0]
  return `${all.slice(0, -1).join(', ')} and ${all[all.length - 1]}`
}

// how long until a time, the way the shrine's refusal says it: "40 minutes", "2 hours and 10 minutes", "about 9 hours"
export function untilWords(ms) {
  const m = Math.max(1, Math.ceil(ms / 60_000))
  if (m < 60) return `${m} ${m === 1 ? 'minute' : 'minutes'}`
  const h = Math.floor(m / 60)
  const rest = m % 60
  if (h < 3) return rest ? `${h} ${h === 1 ? 'hour' : 'hours'} and ${rest} ${rest === 1 ? 'minute' : 'minutes'}` : `${h} ${h === 1 ? 'hour' : 'hours'}`
  return `about ${Math.round(m / 60)} hours`
}

export function sinceLines(d) {
  const out = []
  const v = d?.verdicts || {}
  const t = d?.talk || {}
  if (v.kept) out.push(`${BIRD_NAME} kept ${plural(v.kept, 'thing', 'things')} of yours`)
  // Gone splits two ways. Let go is a verdict on a new thing; taken down
  // for good is a kept thing he lived with a while and then stopped
  // wanting, and the giver's standing moved with it.
  const released = v.released || 0
  const rejected = Math.max(0, (v.gone || 0) - released)
  if (rejected) out.push(`let ${plural(rejected, 'thing', 'things')} go`)
  if (released) out.push(`took ${plural(released, 'thing', 'things')} of yours down from the wall for good`)
  // Still kept, just not on the wall: the wall holds so many and the
  // oldest makes room for the newest.
  if (v.unseated) out.push(`${plural(v.unseated, 'thing', 'things')} of yours came down from the wall to make room, still kept`)
  // Never read: he got busy and it waited too long (30 Oct). Not a verdict on it.
  // Read for him by Glint, the friend he made, before it could expire (31 Oct)
  if (v.glint) out.push(`Glint read ${plural(v.glint, 'thing', 'things')} of yours for him`)
  if (v.expired) out.push(`${plural(v.expired, 'thing', 'things')} of yours expired before he got to ${v.expired === 1 ? 'it' : 'them'}`)
  if (d?.mentions) out.push(`${BIRD_NAME} wrote about you ${d.mentions === 1 ? 'once' : `${d.mentions} times`}`)
  if (d?.shaped) out.push(`${plural(d.shaped, 'thing', 'things')} he did came from you`)
  if (t.likes) out.push(`${people(t.likers, t.likes)} liked what you left`)
  if (t.comments) out.push(`${people(t.commenters, t.comments)} said something under it`)
  if (t.pinoReplies) out.push(`${BIRD_NAME} answered under what you left`)
  // First, when it is there: a question waiting on you is the one thing
  // on this strip you can actually do something about.
  if (d?.asked) out.unshift(`${BIRD_NAME} asked you ${d.asked === 1 ? 'something' : `${d.asked} things`}`)
  // A rung moved. Up is the good news; down is said as plainly, with
  // both names, so nobody has to work out what changed.
  if (d?.rank?.from && d?.rank?.to) {
    out.unshift(d.rank.up
      ? `he knows you better now: ${d.rank.to}`
      : `your standing dropped: ${d.rank.from} to ${d.rank.to}`)
  }
  return out
}
